import React from "react"
import PropTypes from "prop-types"
import { ListItem, Link as ExternalLink, ListItemText } from "@material-ui/core"
import {Link as InternalLink} from 'gatsby';
import { makeStyles } from "@material-ui/core/styles"
import { linkReset } from "../../helpers/linkReset"

const internalStyle = makeStyles(theme => ({
    selected: {
        backgroundColor: theme.palette.action.selected,
        "&:hover": {
            backgroundColor: theme.palette.action.selected,
        },
    },
}));

const InternalButton = ({ name, link, mobileonly }) => {
    const classes = internalStyle();

    return <ListItem
        button
        component={InternalLink}
        to={link}
        activeClassName={classes.selected}
        partiallyActive={!mobileonly}
    >
        <ListItemText primary={name} />
    </ListItem>
}

const externalStyle = makeStyles(theme => ({
    root: {
        ...linkReset,
    },
}));

const ExternalButton = ({name, link}) => {
    const classes = externalStyle();

    return <ListItem
        button
        className={classes.root}
        component={ExternalLink}
        href={link}
    >
        <ListItemText primary={name} />
    </ListItem>;
}

export const MobileButton = (props) => {
    return props.external
        ? <ExternalButton {...props} />
        : <InternalButton {...props} />;
}

MobileButton.propTypes = {
    name: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    external: PropTypes.bool.isRequired,
    mobileOnly: PropTypes.bool,
}